import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subheader col-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "社員マスタ編集")
], -1)
const _hoisted_4 = { class: "subheader-block ml-auto demo" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-xl-12" }
const _hoisted_15 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "編集項目"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1)
const _hoisted_17 = {
  class: "panel-container show",
  id: "panel-editers"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1)
const _hoisted_19 = { class: "panel-content contents" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "社員コード", -1)
const _hoisted_22 = { class: "col-md-5 contCnt" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "社員番号", -1)
const _hoisted_25 = { class: "col-md-5 contCnt" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "社員名", -1)
const _hoisted_28 = { class: "col-md-5 contCnt" }
const _hoisted_29 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "社員名(英語)", -1)
const _hoisted_32 = { class: "col-md-5 contCnt" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "ふりがな", -1)
const _hoisted_35 = { class: "col-md-5 contCnt" }
const _hoisted_36 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "メールアドレス", -1)
const _hoisted_39 = { class: "col-md-5 contCnt" }
const _hoisted_40 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "拠点", -1)
const _hoisted_43 = { class: "col-md-5 contCnt" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "部署", -1)
const _hoisted_46 = { class: "col-md-5 contCnt" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "上長1", -1)
const _hoisted_49 = { class: "col-md-5 contCnt" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_52 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_53 = { class: "col-md-6 contTitle" }
const _hoisted_54 = { class: "custom-control custom-checkbox" }
const _hoisted_55 = ["checked"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbMail1"
}, "メール通知", -1)
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "上長2", -1)
const _hoisted_59 = { class: "col-md-5 contCnt" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_62 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_63 = { class: "col-md-6 contTitle" }
const _hoisted_64 = { class: "custom-control custom-checkbox" }
const _hoisted_65 = ["checked"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbMail2"
}, "メール通知", -1)
const _hoisted_67 = { class: "row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "上長3", -1)
const _hoisted_69 = { class: "col-md-5 contCnt" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_72 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_73 = { class: "col-md-6 contTitle" }
const _hoisted_74 = { class: "custom-control custom-checkbox" }
const _hoisted_75 = ["checked"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbMail3"
}, "メール通知", -1)
const _hoisted_77 = { class: "row" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "上長4", -1)
const _hoisted_79 = { class: "col-md-5 contCnt" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_82 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_83 = { class: "col-md-6 contTitle" }
const _hoisted_84 = { class: "custom-control custom-checkbox" }
const _hoisted_85 = ["checked"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbMail4"
}, "メール通知", -1)
const _hoisted_87 = { class: "row" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "上長5", -1)
const _hoisted_89 = { class: "col-md-5 contCnt" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_92 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_93 = { class: "col-md-6 contTitle" }
const _hoisted_94 = { class: "custom-control custom-checkbox" }
const _hoisted_95 = ["checked"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbMail5"
}, "メール通知", -1)
const _hoisted_97 = { class: "row" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請承認1", -1)
const _hoisted_99 = { class: "col-md-5 contCnt" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_102 = { class: "row" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請承認2", -1)
const _hoisted_104 = { class: "col-md-5 contCnt" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請承認3", -1)
const _hoisted_109 = { class: "col-md-5 contCnt" }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_112 = { class: "row" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "個人承認1", -1)
const _hoisted_114 = { class: "col-md-5 contCnt" }
const _hoisted_115 = { class: "row" }
const _hoisted_116 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_117 = { class: "row" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "個人承認2", -1)
const _hoisted_119 = { class: "col-md-5 contCnt" }
const _hoisted_120 = { class: "row" }
const _hoisted_121 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_122 = { class: "row" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "個人承認3", -1)
const _hoisted_124 = { class: "col-md-5 contCnt" }
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-md-6 contCnt selectedClear" }
const _hoisted_127 = { class: "row" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "ログインID", -1)
const _hoisted_129 = { class: "col-md-5 contCnt" }
const _hoisted_130 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_131 = { class: "row" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "パスワード", -1)
const _hoisted_133 = { class: "col-md-5 contCnt" }
const _hoisted_134 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_135 = {
  key: 1,
  class: "error-message4vali"
}
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-12 contTitle",
  style: {"color":"var(--theme-fusion-50)","font-size":"12px"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon-stack icon-stack-lg",
    style: {"font-size":"14px"}
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
  ]),
  /*#__PURE__*/_createTextVNode(" セキュリティの為、パスワードは表示されません。変更する場合のみ、変更したいパスワードを入力してください。 ")
], -1)
const _hoisted_137 = { class: "row" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "システム権限", -1)
const _hoisted_139 = { class: "col-md-5 contCnt" }
const _hoisted_140 = { class: "row" }
const _hoisted_141 = { class: "col-md-6 contCnt" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 contTitle" }, "請求承認", -1)
const _hoisted_143 = { class: "col-md-3 contCnt" }
const _hoisted_144 = { class: "row" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)
const _hoisted_146 = { class: "col-md-5 contCnt" }
const _hoisted_147 = { class: "row" }
const _hoisted_148 = { class: "col-md-6 contCnt" }
const _hoisted_149 = { class: "custom-control custom-checkbox" }
const _hoisted_150 = ["checked"]
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbClaimNoChange"
}, "請求No変更", -1)
const _hoisted_152 = { class: "col-md-6 contCnt" }
const _hoisted_153 = { class: "custom-control custom-checkbox" }
const _hoisted_154 = ["checked"]
const _hoisted_155 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbExcelOutput"
}, "一覧画面Excel出力", -1)
const _hoisted_156 = { class: "row" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)
const _hoisted_158 = { class: "col-md-5 contCnt" }
const _hoisted_159 = { class: "row" }
const _hoisted_160 = { class: "col-md-6 contCnt" }
const _hoisted_161 = { class: "custom-control custom-checkbox" }
const _hoisted_162 = ["checked"]
const _hoisted_163 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "hokensinseisya"
}, "保険申請者", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 contCnt" }, null, -1)
const _hoisted_165 = { class: "row" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "表示順", -1)
const _hoisted_167 = { class: "col-md-5 contCnt" }
const _hoisted_168 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_169 = { class: "row" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "勤怠機能用表示順", -1)
const _hoisted_171 = { class: "col-md-5 contCnt" }
const _hoisted_172 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_173 = { class: "row" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "出向中", -1)
const _hoisted_175 = { class: "col-md-5 contCnt" }
const _hoisted_176 = { class: "custom-control custom-checkbox" }
const _hoisted_177 = ["checked"]
const _hoisted_178 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbFlagOnloan"
}, null, -1)
const _hoisted_179 = { class: "panel-content contents border-faded border-left-0 border-right-0 border-down-0" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "row md-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-auto contTitle font-weight-bold" }, " メール配信設定 ")
], -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, null, -1)
const _hoisted_182 = { class: "row" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "　配信先アドレス", -1)
const _hoisted_184 = { class: "col-md-5 contCnt" }
const _hoisted_185 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_186 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "カンマ（,）区切りで複数アドレス対応可能です。", -1)
const _hoisted_187 = /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, null, -1)
const _hoisted_188 = { class: "row" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "　配信対象アラート", -1)
const _hoisted_190 = { class: "col-md-5 contCnt" }
const _hoisted_191 = { class: "custom-control custom-checkbox" }
const _hoisted_192 = ["checked"]
const _hoisted_193 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckClaimreq"
}, "請求書承認依頼通知", -1)
const _hoisted_194 = { class: "custom-control custom-checkbox" }
const _hoisted_195 = ["checked"]
const _hoisted_196 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckClaimok"
}, "請求書承認通知", -1)
const _hoisted_197 = { class: "custom-control custom-checkbox" }
const _hoisted_198 = ["checked"]
const _hoisted_199 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckClaimnot"
}, "請求書差し戻し通知", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, null, -1)
const _hoisted_201 = { class: "custom-control custom-checkbox" }
const _hoisted_202 = ["checked"]
const _hoisted_203 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckPeriodsale"
}, "販売契約期間満期接近通知", -1)
const _hoisted_204 = { class: "custom-control custom-checkbox" }
const _hoisted_205 = ["checked"]
const _hoisted_206 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckPeriodsupply"
}, "仕入契約期間満期接近通知", -1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, null, -1)
const _hoisted_208 = { class: "custom-control custom-checkbox" }
const _hoisted_209 = ["checked"]
const _hoisted_210 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckReqreqest"
}, "申請書承認依頼通知", -1)
const _hoisted_211 = { class: "custom-control custom-checkbox" }
const _hoisted_212 = ["checked"]
const _hoisted_213 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckReqok"
}, "申請書承認通知", -1)
const _hoisted_214 = { class: "custom-control custom-checkbox" }
const _hoisted_215 = ["checked"]
const _hoisted_216 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckReqnot"
}, "申請書差戻通知", -1)
const _hoisted_217 = { class: "custom-control custom-checkbox" }
const _hoisted_218 = ["checked"]
const _hoisted_219 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckReqdown"
}, "申請書取下通知", -1)
const _hoisted_220 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)
const _hoisted_221 = { class: "text-success fw-500" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)
const _hoisted_225 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_226 = { class: "modal-footer" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_229 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add())),
              disabled: _ctx.btnDisable,
              class: "btn btn-info waves-effect waves-themed"
            }, [
              _hoisted_6,
              _createTextVNode("追加 ")
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upd(false))),
              disabled: _ctx.btnDisable,
              class: "btn btn-info waves-effect waves-themed"
            }, [
              _hoisted_8,
              _createTextVNode("登録 ")
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.delConf())),
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed"
            }, [
              _hoisted_10,
              _createTextVNode("削除 ")
            ], 8, _hoisted_9))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/syainlist')))
        }, [
          _hoisted_12,
          _createTextVNode("戻る ")
        ], 8, _hoisted_11)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtUserCd",
                    class: "form-control form-control-sm",
                    disabled: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.delegate.c_staff_id) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtUserNumber",
                    class: "form-control form-control-sm",
                    maxlength: "10",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.delegate.c_staff_number) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_number]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtUserNm",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.delegate.c_staff_name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_name]
                  ]),
                  (_ctx.errors?.path === 'staffName')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtUserNm",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delegate.c_staff_name_en) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_name_en]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtFurigana",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delegate.c_staff_name_pt) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_name_pt]
                  ]),
                  (_ctx.errors?.path === 'furigana')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtMail_address",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.c_staff_mail) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_mail]
                  ]),
                  (_ctx.errors?.path === 'email')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4BranchId,
                    modelValue: _ctx.delegate.c_branch_id,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.delegate.c_branch_id) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4StaffDepart,
                    modelValue: _ctx.delegate.c_staff_depart,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.delegate.c_staff_depart) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(1),
                        modelValue: _ctx.delegate.c_staff_elder_user_id_1,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.delegate.c_staff_elder_user_id_1) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"]),
                      (_ctx.errors?.path === 'elderUser')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "cbMail1",
                          checked: (_ctx.delegate.c_staff_elder_user_flag_mail_1 as any),
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (
                            _ctx.delegate.c_staff_elder_user_flag_mail_1 =
                              _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_55),
                        _hoisted_56
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(2),
                        modelValue: _ctx.delegate.c_staff_elder_user_id_2,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.delegate.c_staff_elder_user_id_2) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"]),
                      (_ctx.errors?.path === 'elderUser')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "cbMail2",
                          checked: (_ctx.delegate.c_staff_elder_user_flag_mail_2 as any),
                          onChange: _cache[15] || (_cache[15] = ($event: any) => (
                            _ctx.delegate.c_staff_elder_user_flag_mail_2 =
                              _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_65),
                        _hoisted_66
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(3),
                        modelValue: _ctx.delegate.c_staff_elder_user_id_3,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.delegate.c_staff_elder_user_id_3) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"]),
                      (_ctx.errors?.path === 'elderUser')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "cbMail3",
                          checked: (_ctx.delegate.c_staff_elder_user_flag_mail_3 as any),
                          onChange: _cache[17] || (_cache[17] = ($event: any) => (
                            _ctx.delegate.c_staff_elder_user_flag_mail_3 =
                              _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_75),
                        _hoisted_76
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(4),
                        modelValue: _ctx.delegate.c_staff_elder_user_id_4,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.delegate.c_staff_elder_user_id_4) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"]),
                      (_ctx.errors?.path === 'elderUser')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "cbMail4",
                          checked: (_ctx.delegate.c_staff_elder_user_flag_mail_4 as any),
                          onChange: _cache[19] || (_cache[19] = ($event: any) => (
                            _ctx.delegate.c_staff_elder_user_flag_mail_4 =
                              _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_85),
                        _hoisted_86
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(5),
                        modelValue: _ctx.delegate.c_staff_elder_user_id_5,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_staff_elder_user_id_5) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"]),
                      (_ctx.errors?.path === 'elderUser')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "cbMail5",
                          checked: (_ctx.delegate.c_staff_elder_user_flag_mail_5 as any),
                          onChange: _cache[21] || (_cache[21] = ($event: any) => (
                            _ctx.delegate.c_staff_elder_user_flag_mail_5 =
                              _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_95),
                        _hoisted_96
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _hoisted_98,
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(6),
                        modelValue: _ctx.delegate.c_staff_application_staff_id_1,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.delegate.c_staff_application_staff_id_1) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("div", _hoisted_106, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(7),
                        modelValue: _ctx.delegate.c_staff_application_staff_id_2,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.delegate.c_staff_application_staff_id_2) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _hoisted_108,
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(8),
                        modelValue: _ctx.delegate.c_staff_application_staff_id_3,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.delegate.c_staff_application_staff_id_3) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _hoisted_113,
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(9),
                        modelValue: _ctx.delegate.c_staff_individual_staff_id_1,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.delegate.c_staff_individual_staff_id_1) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_117, [
                _hoisted_118,
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("div", _hoisted_121, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(10),
                        modelValue: _ctx.delegate.c_staff_individual_staff_id_2,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.delegate.c_staff_individual_staff_id_2) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_122, [
                _hoisted_123,
                _createElementVNode("div", _hoisted_124, [
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("div", _hoisted_126, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.getOpStaffs(11),
                        modelValue: _ctx.delegate.c_staff_individual_staff_id_3,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.delegate.c_staff_individual_staff_id_3) = $event)),
                        reduce: (label) => label.c_staff_id,
                        label: "c_staff_name"
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_127, [
                _hoisted_128,
                _createElementVNode("div", _hoisted_129, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtLogin_id",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.delegate.c_staff_login_id) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_login_id]
                  ]),
                  (_ctx.errors?.path === 'staffLoginid')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_131, [
                _hoisted_132,
                _createElementVNode("div", _hoisted_133, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtPassword",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.delegate.c_staff_login_pass) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_login_pass]
                  ]),
                  (_ctx.errors?.path === 'staffPassNew')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true),
                  (_ctx.errors?.path === 'staffPassUpd')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_135, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true),
                  _hoisted_136
                ])
              ]),
              _createElementVNode("div", _hoisted_137, [
                _hoisted_138,
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.op4AuthType,
                        modelValue: _ctx.delegate.c_staff_auth_type,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.delegate.c_staff_auth_type) = $event)),
                        reduce: (label) => label.code
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ]),
                    _hoisted_142,
                    _createElementVNode("div", _hoisted_143, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.op4AuthClaim,
                        modelValue: _ctx.delegate.c_staff_flag_auth_claim,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.delegate.c_staff_flag_auth_claim) = $event)),
                        reduce: (label) => label.code
                      }, null, 8, ["options", "modelValue", "reduce"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_144, [
                _hoisted_145,
                _createElementVNode("div", _hoisted_146, [
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _createElementVNode("div", _hoisted_149, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "cbClaimNoChange",
                          checked: (_ctx.delegate.c_staff_flag_auth_claimnum_chg as any),
                          onChange: _cache[32] || (_cache[32] = ($event: any) => (
                            _ctx.delegate.c_staff_flag_auth_claimnum_chg =
                              _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_150),
                        _hoisted_151
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _createElementVNode("div", _hoisted_153, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "cbExcelOutput",
                          checked: (_ctx.delegate.c_staff_flag_auth_listexprt as any),
                          onChange: _cache[33] || (_cache[33] = ($event: any) => (
                            _ctx.delegate.c_staff_flag_auth_listexprt = _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_154),
                        _hoisted_155
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_156, [
                _hoisted_157,
                _createElementVNode("div", _hoisted_158, [
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "hokensinseisya",
                          checked: (_ctx.delegate.c_staff_flag_insurance as any),
                          onChange: _cache[34] || (_cache[34] = ($event: any) => (
                            _ctx.delegate.c_staff_flag_insurance = _ctx.cnvCb($event)
                          ))
                        }, null, 40, _hoisted_162),
                        _hoisted_163
                      ])
                    ]),
                    _hoisted_164
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_165, [
                _hoisted_166,
                _createElementVNode("div", _hoisted_167, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.delegate.c_staff_show_order) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_show_order]
                  ]),
                  (_ctx.errors?.path === 'showOrder')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_168, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_169, [
                _hoisted_170,
                _createElementVNode("div", _hoisted_171, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.delegate.c_staff_show_order_attendandce) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_show_order_attendandce]
                  ]),
                  (_ctx.errors?.path === 'showOrder4Attendance')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_172, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_173, [
                _hoisted_174,
                _createElementVNode("div", _hoisted_175, [
                  _createElementVNode("div", _hoisted_176, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "cbFlagOnloan",
                      checked: (_ctx.delegate.c_staff_flag_onloan as any),
                      onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.delegate.c_staff_flag_onloan = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_177),
                    _hoisted_178
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_179, [
              _hoisted_180,
              _hoisted_181,
              _createElementVNode("div", _hoisted_182, [
                _hoisted_183,
                _createElementVNode("div", _hoisted_184, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtMail_alert",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.delegate.c_staff_alert_mail) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_staff_alert_mail]
                  ]),
                  (_ctx.errors?.path === 'email')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_185, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true),
                  _hoisted_186
                ])
              ]),
              _hoisted_187,
              _createElementVNode("div", _hoisted_188, [
                _hoisted_189,
                _createElementVNode("div", _hoisted_190, [
                  _createElementVNode("div", _hoisted_191, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckClaimreq",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_claim_request as any),
                      onChange: _cache[39] || (_cache[39] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_claim_request = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_192),
                    _hoisted_193
                  ]),
                  _createElementVNode("div", _hoisted_194, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckClaimok",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_claim_approval as any),
                      onChange: _cache[40] || (_cache[40] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_claim_approval =
                          _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_195),
                    _hoisted_196
                  ]),
                  _createElementVNode("div", _hoisted_197, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckClaimnot",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_claim_return as any),
                      onChange: _cache[41] || (_cache[41] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_claim_return = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_198),
                    _hoisted_199
                  ]),
                  _hoisted_200,
                  _createElementVNode("div", _hoisted_201, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckPeriodsale",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_contract_period_sales as any),
                      onChange: _cache[42] || (_cache[42] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_contract_period_sales =
                          _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_202),
                    _hoisted_203
                  ]),
                  _createElementVNode("div", _hoisted_204, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckPeriodsupply",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_contract_period_supply as any),
                      onChange: _cache[43] || (_cache[43] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_contract_period_supply =
                          _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_205),
                    _hoisted_206
                  ]),
                  _hoisted_207,
                  _createElementVNode("div", _hoisted_208, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckReqreqest",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_request_request as any),
                      onChange: _cache[44] || (_cache[44] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_request_request =
                          _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_209),
                    _hoisted_210
                  ]),
                  _createElementVNode("div", _hoisted_211, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckReqok",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_request_approval as any),
                      onChange: _cache[45] || (_cache[45] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_request_approval =
                          _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_212),
                    _hoisted_213
                  ]),
                  _createElementVNode("div", _hoisted_214, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckReqnot",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_request_return as any),
                      onChange: _cache[46] || (_cache[46] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_request_return =
                          _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_215),
                    _hoisted_216
                  ]),
                  _createElementVNode("div", _hoisted_217, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "ckReqdown",
                      class: "custom-control-input",
                      checked: (_ctx.delegate.c_staff_flag_mail_request_withdrawal as any),
                      onChange: _cache[47] || (_cache[47] = ($event: any) => (
                        _ctx.delegate.c_staff_flag_mail_request_withdrawal =
                          _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_218),
                    _hoisted_219
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[48] || (_cache[48] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_220,
        _createElementVNode("span", _hoisted_221, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_222
      ]),
      footer: _withCtx(() => [
        _hoisted_223
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _hoisted_224,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_225
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_226, [
          _createElementVNode("button", {
            onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_227,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_228
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_229, [
          _createElementVNode("button", {
            onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}